module.exports = __webpack_public_path__ + "img/background-technology-tablet.c5469ec5.jpg";